module.exports = __webpack_public_path__ + "static/img/yyzz.af60c73a.jpg";